const messages = {
  title: "Prace konserwacyjne!",
  description:
    'Obecnie trwają niezbędne prace konserwacyjne na serwerach.<br/><br/>Dlatego dostęp do <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> jest obecnie niedostępny.<br/><br/>Prosimy o cierpliwość i dziękujemy za zrozumienie.<br/><br/> Twój zespół Bridgestone',
}
export default {
  messages
}
